import { BundleAccordions as BundleAccordionsBase } from './components/BundleAccordions';
import { BundleBuybox as BundleBuyboxBase } from './components/BundleBuybox';
import {
  BundleConsumerCardMessaging as BundleConsumerCardMessagingBase
} from './components/BundleConsumerCardMessaging';
import { BundleFulfillment as BundleFulfillmentBase } from './components/BundleFulfillment';
import { BundleMediaGallery as BundleMediaGalleryBase } from './components/BundleMediaGallery';
import { BundleMini } from './components/BundleMini';
import { BundlePageAnalytics as BundlePageAnalyticsBase } from './components/BundlePageAnalytics';
import { BundlePrice as BundlePriceBase } from './components/BundlePrice';
import { BundleProductDetails as BundleProductDetailsBase } from './components/BundleProductDetails';
import { BundleProductList as BundleProductListBase } from './components/BundleProductList';
import { BundleProductOverview as BundleProductOverviewBase } from './components/BundleProductOverview';
import { BundlePromotion as BundlePromotionBase } from './components/BundlePromotion';
import { BundleSalientPoints as BundleSalientPointsBase } from './components/BundleSalientPoints';
import { BundleShare } from './components/BundleShare';
import { BundleSpecifications as BundleSpecificationsBase } from './components/BundleSpecifications';
import { BundleStickyNav as BundleStickyNavBase } from './components/BundleStickyNav';
import { BundleSummary as BundleSummaryBase } from './components/BundleSummary';
import { BundleWhatWeOffer as BundleWhatWeOfferBase } from './components/BundleWhatWeOffer';
import { BundleProductOverviewAccordionTitle } from './components/BundleProductOverviewAccordionTitle';
import { BundleSpecificationsAccordionTitle } from './components/BundleSpecificationsAccordionTitle';
import { BundleMetadata as BaseBundleMetadata } from './components/BundleMetadata';
import { BundleAlert as BaseBundleAlert } from './components/BundleAlert';
import { BundleTrackOOS as BaseBundleTrackOOS } from './components/BundleTrackOOS';
import { BundleDeliveryDate as BaseBundleDeliveryDate } from './components/BundleDeliveryDate';

import { useBundleProducts } from './hooks/useBundleProducts';
import useGetCartItems from './hooks/useGetCartItems';
import useProductsFullfilmentValidation from './hooks/useProductsFullfilmentValidation';
import { useBundlePricingDetails } from './hooks/useBundlePricingDetails';
import { withBundleProducts } from './components/WithBundleProducts';
import { getBundleWithPricing } from './utils/bundle-price-utils';
import { getCartData, expandAccessoryQuantities } from './utils/product-bundle-utils';
import { QuickViewLazy } from './components/subcomponents/QuickViewLazy';

const BundleAccordions = withBundleProducts(BundleAccordionsBase);
const BundleBuybox = withBundleProducts(BundleBuyboxBase);
const BundleConsumerCardMessaging = withBundleProducts(BundleConsumerCardMessagingBase);
const BundleFulfillment = withBundleProducts(BundleFulfillmentBase);
const BundleMediaGallery = withBundleProducts(BundleMediaGalleryBase);
const BundlePageAnalytics = withBundleProducts(BundlePageAnalyticsBase);
const BundlePrice = withBundleProducts(BundlePriceBase);
const BundleProductDetails = withBundleProducts(BundleProductDetailsBase);
const BundleProductList = withBundleProducts(BundleProductListBase);
const BundleProductOverview = withBundleProducts(BundleProductOverviewBase);
const BundlePromotion = withBundleProducts(BundlePromotionBase);
const BundleSalientPoints = withBundleProducts(BundleSalientPointsBase);
const BundleSpecifications = withBundleProducts(BundleSpecificationsBase);
const BundleStickyNav = withBundleProducts(BundleStickyNavBase);
const BundleSummary = withBundleProducts(BundleSummaryBase);
const BundleWhatWeOffer = withBundleProducts(BundleWhatWeOfferBase);
const BundleMetadata = withBundleProducts(BaseBundleMetadata);
const BundleAlert = withBundleProducts(BaseBundleAlert);
const BundleTrackOOS = withBundleProducts(BaseBundleTrackOOS);
const BundleDeliveryDate = withBundleProducts(BaseBundleDeliveryDate);

BundleAccordions.displayName = 'BundleAccordions';
BundleBuybox.displayName = 'BundleBuybox';
BundleConsumerCardMessaging.displayName = 'BundleConsumerCardMessaging';
BundleFulfillment.displayName = 'BundleFulfillment';
BundleMediaGallery.displayName = 'BundleMediaGallery';
BundlePageAnalytics.displayName = 'BundlePageAnalytics';
BundlePrice.displayName = 'BundlePrice';
BundleProductDetails.displayName = 'BundleProductDetails';
BundleProductList.displayName = 'BundleProductList';
BundleProductOverview.displayName = 'BundleProductOverview';
BundlePromotion.displayName = 'BundlePromotion';
BundleSalientPoints.displayName = 'BundleSalientPoints';
BundleSpecifications.displayName = 'BundleSpecifications';
BundleStickyNav.displayName = 'BundleStickyNav';
BundleSummary.displayName = 'BundleSummary';
BundleWhatWeOffer.displayName = 'BundleWhatWeOffer';
BundleMetadata.displayName = 'BundleMetadata';
BundleAlert.displayName = 'BundleAlert';
BundleTrackOOS.displayName = 'BundleTrackOOS';
BundleDeliveryDate.displayName = 'BundleDeliveryDate';

export {
  BundleAccordions,
  BundleBuybox,
  BundleConsumerCardMessaging,
  BundleFulfillment,
  BundleMediaGallery,
  BundleMini,
  BundlePageAnalytics,
  BundlePrice,
  BundleProductDetails,
  BundleProductList,
  BundleProductOverview,
  BundlePromotion,
  BundleSalientPoints,
  BundleShare,
  BundleSpecifications,
  BundleStickyNav,
  BundleSummary,
  BundleWhatWeOffer,
  BundleProductOverviewAccordionTitle,
  BundleSpecificationsAccordionTitle,
  QuickViewLazy,
  BundleMetadata,
  BundleAlert,
  BundleTrackOOS,
  BundleDeliveryDate,

  useBundleProducts,
  useProductsFullfilmentValidation,
  useBundlePricingDetails,
  useGetCartItems,

  getBundleWithPricing,
  getCartData,
  expandAccessoryQuantities
};
